import * as C from "./actionTypes";

export const requestAddNewDepositFile = (newFile) => {
    return {
        type: C.REQUEST_ADD_NEW_DEPO_FILE,
        newFile: newFile
    }
}

export const onDrop = (files) => {
    return {
        type: C.ON_DROP,
        files: files,
    }
}

export const setInformations = (depositInformations) => {
    return {
        type: C.SET_INFORMATIONS,
        depositInformations: depositInformations
    }
}

export const setToaster = (toasterInfo) => {
    return {
        type: C.SET_TOASTER,
        toasterInfo: toasterInfo
    }
}

export const removeToaster = () => {
    return {
        type: C.REMOVE_TOASTER
    }
}

export const setLoadPercent = val => {
    return {
        type: C.SET_LOAD_PERCENT,
        percent: val
    }
}

export const removeButton = check => {
    return {
        type: C.REMOVE_BUTTON,
        check: check
    }
}

export const removeFileFromList = index => {
    return {
        type: C.REMOVE_FILE_FROM_LIST,
        index: index
    }
}

export const removeFileFromUploadsList = fileIds => {
    return {
        type: C.REMOVE_FILE_FROM_UPLOADS_LIST,
        fileIds
    }
}

export const resetAllProps = () => {
    return {
        type: C.RESET_ALL_PROPS,
    }
}

export const checkIfSent = check => {
    return {
        type: C.CHECK_IF_SENT,
        check: check
    }
}

export const requestGetFiles = () => {
    return {
        type: C.REQUEST_GET_FILES
    }
}

export const setListFiles = (files) => {
    return {
        type: C.SET_LIST_FILES,
        files: files
    }
}

export const readyToSend = () => {
    return {
        type: C.READY_TO_SEND,
    }
}

export const setReadyToSend = (check) => {
    return {
        type: C.SET_READY_TO_SEND,
        check: check
    }
}

export const setAlmostReady = (check) => {
    return {
        type: C.SET_ALMOST_READY,
        check: check
    }
}

export const setValueSelect = (value) => {
    return {
        type: C.SET_VALUE_SELECT,
        value: value
    }
}
